/**
 * Created by ok on 6/10/16.
 */
import trimStart from 'lodash/trimStart';
import tinycolor from 'tinycolor2';

export function parseToHsl( value ) {
    const color = tinycolor( value );
    return color.isValid() ? color.toHsl() : console.warn( "INVALID_COLOR_VALUE in parseToHsl" );
}

export function parseToRgb( value ) {
    const color = tinycolor( value );
    return color.isValid() ? color.toRgb() : console.warn( "INVALID_COLOR_VALUE in parseToRgb" );
}

export function parseToRgbString( value ) {
    const color = tinycolor( value );
    return color.isValid() ? color.toRgbString() : console.warn( "INVALID_COLOR_VALUE in parseToRgbString" );
}

export function parseToHslString( value ) {
    const color = tinycolor( value );
    return color.isValid() ? color.toString( "hsl" ) : console.warn( "INVALID_COLOR_VALUE in parseToHslString" );
}

export function parseToHexString( value ) {
    const color = tinycolor( value );
    return color.isValid() ? color.toString( "hex6" ) : console.warn( "INVALID_COLOR_VALUE in parseToHexString" );
}

export function equals( value1, value2 ) {
    return tinycolor.equals( value1, value2 );
}

export function isDark( value ) {
    const color = tinycolor( value );
    return color.isValid() ? color.isDark() : console.warn( "INVALID_COLOR_VALUE in isDark" );
}

export function isValidHex( value ) {
    return tinycolor( value ).isValid();
}

/**
 * Returns a rgba color with alpha set to the provided value.
 *
 * @param value
 *  Valid color input value.
 * @param alpha
 *  Alpha value between 0 and 1.
 * @returns {*}
 */
export function setAlpha(value, alpha) {
    const color = tinycolor( value );
    const color2 = color.clone;
    return color2.isValid() ? color2.setAlpha(alpha).toRgbString() : console.warn( "INVALID_COLOR_VALUE in setAlpha" );
}

/**
 * Takes an array, removes the leading '#' and returns the values
 * as an comma separated string for use in uri queries.
 *
 * @param colors
 * @returns {string}
 */
export const color2string = ( colors ) => {

    let trimmedColors = [];
    trimmedColors = colors.map( ( color ) => {
        return tinycolor( color ).toHex();
    } );
    return trimmedColors.join( ',' );
};

/**
 * Takes an array, removes the leading '#' and returns the values
 * as an comma separated string for use in uri queries.
 *
 * @param colors
 * @returns {string}
 */
export const color2HexString = ( colors ) => {

    let trimmedColors = [];
    trimmedColors = colors.map( ( color ) => {
        return "#" + tinycolor( color ).toHex();
    } );
    return trimmedColors.join( ', ' );
};

/**
 * Takes an comma separated string - mostly from uri queries - and returns
 * an array with hexcolorvalues.
 *
 * @param colors
 * @returns {Array}
 */
export const string2color = ( colors ) => {
    let colorArray = [];
    colorArray = colors.split( ',' ).map( ( color ) => {
        return tinycolor( '#' + color );
    } );
    return colorArray;
};

/**
 * Calculates new saturation/lightness (0-1) values of a hsl color from a slider
 * value (0-1).
 *
 * @param originalValue
 * @param sliderValue
 * @returns {*}
 */
export const interpolateSlider = ( originalValue, sliderValue ) => {
    sliderValue = parseFloat( sliderValue );
    originalValue = parseFloat( originalValue );
    if ( Math.abs( sliderValue * 1 - originalValue * 1 ) === 0 ) {
        return parseFloat( originalValue );
    }
    if ( sliderValue <= 0.5 ) {
        return ( sliderValue / 0.5 ) * originalValue;
    } else {
        return originalValue + (1 - originalValue) * ( (sliderValue - 0.5) / 0.5 );
    }
};



// WEBPACK FOOTER //
// ./src/helper/ColorUtils.js